import React from "react";
import { CourseStateTooltip } from "../../../pages/courses/components/tooltips";

export function StatusTitle(props) {
    return (
        <>
            {props.title}
            <CourseStateTooltip />
        </>
    );
}
